import { render, staticRenderFns } from "./ConfirmBuy.vue?vue&type=template&id=4068408e&scoped=true&"
import script from "./ConfirmBuy.vue?vue&type=script&lang=ts&"
export * from "./ConfirmBuy.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmBuy.vue?vue&type=style&index=0&id=4068408e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068408e",
  null
  
)

export default component.exports